import { render, staticRenderFns } from "./AssigmentStats.vue?vue&type=template&id=665d1be2&scoped=true&"
import script from "./AssigmentStats.vue?vue&type=script&lang=js&"
export * from "./AssigmentStats.vue?vue&type=script&lang=js&"
import style0 from "./AssigmentStats.vue?vue&type=style&index=0&id=665d1be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d1be2",
  null
  
)

export default component.exports